import { useTranslation } from 'react-i18next';

const StackingCards = () => {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-10 sm:py-12 md:py-16 px-4 md:px-8 bg-[#F0F0F0]">
      {/* Container avec fond blanc et bords arrondis comme At-scale */}
      <div className="max-w-[1400px] mx-auto bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-10 md:p-16 lg:p-20 shadow-sm">
        
        {/* Contenu centré */}
        <div className="max-w-4xl mx-auto text-center">
          
          {/* Badge */}
          <div className="inline-flex items-center px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg bg-gray-50 border border-gray-200 mb-6 sm:mb-8 md:mb-12">
            <span className="text-xs sm:text-sm text-gray-600 font-medium uppercase tracking-wider">{t('stackingCards.badge')}</span>
          </div>

          {/* Titre principal - Style At-scale : light, élégant */}
          <h2 className="text-xl sm:text-3xl md:text-4xl lg:text-5xl text-gray-900 leading-[1.3] sm:leading-[1.2] mb-6 sm:mb-8 md:mb-10">
            <span className="block">{t('stackingCards.title1')} <span className="text-[#2A41E5] font-bold italic underline decoration-2 underline-offset-4 sm:underline-offset-8">{t('stackingCards.sparring')}</span></span>
            <span className="block"><span className="text-[#2A41E5] font-bold italic underline decoration-2 underline-offset-4 sm:underline-offset-8">{t('stackingCards.partner')}</span> {t('stackingCards.title2')}</span>
            <span className="block">{t('stackingCards.title3')}</span>
          </h2>
          
          {/* Description */}
          <p className="text-sm sm:text-base md:text-lg text-gray-600 leading-relaxed">
            {t('stackingCards.description1')}
            <br /><br />
            {t('stackingCards.description2')}
            <br /><br />
            {t('stackingCards.description3')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default StackingCards;
